export default __webpack_public_path__ + "static/media/hideandseek-coming-soon.bc4d507e.png";